(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/models/my-receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/models/my-receivers.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.models.MyReceivers = Backbone.Model.extend({
    defaults: {
      hasReceivers: svs.grassroots.data.hasReceivers ?
        svs.grassroots.data.hasReceivers :
        false
    }
  });
})(Backbone, _, svs);


 })(window);